import styled from "styled-components";

import { Value } from "./value";

const Container = styled.div`
  padding: 0 5px;
  text-align: center;
  display: inline-block;
  > .text {
    padding: 5px;
  }
`;

interface RateProps {
  qualificationName: string;
  qualificationLabel: string;
  value?: number;
  onChange: (value: Record<string, number>) => void;
}

export function Rate(props: RateProps) {
  const { qualificationName, qualificationLabel, value = 0, onChange } = props;

  return (
    <Container>
      <div>
        <Value unit="$" name={qualificationName} value={value} onChange={onChange} />/ hr
      </div>
      <div className="text">{qualificationLabel}</div>
    </Container>
  );
}
